import { all } from 'redux-saga/effects'

import { signinSaga } from './signin'
import { updatePasswordSaga } from './updatePassword'

export default function* authSaga() {
  yield all([signinSaga(), updatePasswordSaga()])
}
